import { render } from "./ModalRecipeForm.vue?vue&type=template&id=07341ff2"
import script from "./ModalRecipeForm.vue?vue&type=script&lang=js"
export * from "./ModalRecipeForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__